import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fide-rating-chess-tournament',
  templateUrl: './fide-rating-chess-tournament.component.html',
  styleUrls: ['./fide-rating-chess-tournament.component.scss']
})
export class FideRatingChessTournamentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
